// extracted by mini-css-extract-plugin
export default {"singlePage":"styles_singlePage__kMUA9","mainPageContainer":"styles_mainPageContainer__o6niX","lowerContainer":"styles_lowerContainer__qQv0G","poweredBy":"styles_poweredBy__MH-uE"};